import PedagogicLink from "./PedagogicLink";

export default PedagogicLink;
